import { Table, Tooltip } from "antd";
import { useTranslation } from "react-i18next";

import type { ColumnsType } from "antd/es/table";
import { IRedeemCoupon } from "@interfaces";

import { memo } from "react";
import dayjs from "dayjs";

interface IProps {
  data: IRedeemCoupon[];
  callback: () => void;
}
export const CdicRedeemTable = memo(({ data }: IProps) => {
  const { t } = useTranslation();

  const dataSource: IRedeemCoupon[] = data;

  const columns: ColumnsType<IRedeemCoupon> = [
    {
      title: t("page.coupon_code"),
      dataIndex: "couponCode",
      key: "1",
    },
    {
      title: t("page.service_category"),
      dataIndex: "category",
      key: "7",
    },
    {
      title: t("page.client_name"),
      dataIndex: "client",
      key: "2",
      render: (_, record) => <span>{record?.client?.name}</span>,
      sorter: (a, b) => {
        if (a?.client?.name && b?.client?.name) {
          return a?.client?.name.localeCompare(b?.client?.name);
        } else {
          return 1;
        }
      },
    },
    {
      title: <Tooltip title={t("page.coupon_generated_date")}> {t("page.cg_date")}</Tooltip>,
      dataIndex: "createdAt",
      key: "3",
      render: (data) => <span>{dayjs(data).format("DD-MM-YYYY HH:mm")}</span>,
    },
    {
      title: <Tooltip title={t("page.coupon_redeemed_date")}> {t("page.cr_date")}</Tooltip>,
      dataIndex: "updatedAt",
      key: "4",
      render: (data) => <span>{dayjs(data).format("DD-MM-YYYY HH:mm")}</span>,
    },
    {
      title: t("page.cr_provider_name"),
      dataIndex: "clinic",
      key: "5",
      render: (_, record) => <span>{record?.clinic?.clinicName}</span>,
      sorter: (a, b) => {
        if (a?.clinic?.clinicName && b?.clinic?.clinicName) {
          return a?.clinic?.clinicName.localeCompare(b?.clinic?.clinicName);
        } else {
          return 1;
        }
      },
    },
    {
      title: t("page.cr_doctor_name"),
      dataIndex: "doctor",
      key: "6",
      render: (_, record) => <span>{record?.doctor?.name}</span>,
      sorter: (a, b) => {
        if (a?.doctor?.name && b?.doctor?.name) {
          return a?.doctor?.name.localeCompare(b?.doctor?.name);
        } else {
          return 1;
        }
      },
    },
  ];

  return (
    <Table dataSource={dataSource} rowKey={"couponFamilyId"} columns={columns} pagination={false} />
  );
});
